export const SUCCESS = '000200';
export const FAIL = '000500';

interface CustomParams {
  originUrl?: string;
  isShowError?: boolean;
}
export const getCustomParamsWithHeadrs = (params: CustomParams) => {
  return {
    'x-custom-params': JSON.stringify(params),
  };
};
